import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import ModuleRaceOfReels from "./promotion_modules/ModuleRaceOfReels"

export default function RaceOfReels() {
  const [activeModal, setActiveModal] = useState("")

  const modalComponents = {
    "Race of Reels: Slots Tournament": ModuleRaceOfReels,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const handleRaceOfReels = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("Race of Reels: Slots Tournament")
    }
  }
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const data = promotionsData.find(
    (promo) => promo.title === "Race of Reels: Slots Tournament"
  )
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Race of Reels: Slots Tournament</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Race of Reels: Slots Tournament</h1>
                <h2>Turnover Race for Slots in Pragmatic Play</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>March 03 (12NN) - March 31 (11:59AM), 2026</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                {isLoggedIn && (
                  <div className="promotion-tnc-btn-wrapper">
                    <button
                      className="promotion-cta-btn"
                      onClick={handleRaceOfReels}
                    >
                      Leaderboard
                    </button>
                  </div>
                )}
                <strong>Mechanics: </strong>
                <ol>
                  <li>This promotion is open to all FGH players.</li>
                  <li>
                    Players may participate by playing any Pragmatic Play slots
                    - from Tuesday 12NN until next Tuesday 11:59am.
                  </li>
                  <li>
                    The top 20 players with the highest weekly turnover will win
                    prizes.
                  </li>
                  <li>
                    A minimum weekly turnover of 10,000 is required to qualify
                    for the Top 20 rankings.
                  </li>
                  <li>Crediting of prizes will be every Tuesday at 3:30PM.</li>
                  <li>
                    FGH reserves the right to amend, extend, or terminate this
                    promotion at any time without prior notice.
                  </li>
                  <div className="table-wrapper">
                    <table className="promotion-tnc-table">
                      <thead>
                        <tr>
                          <th colSpan={4}>WEEKLY PRIZES</th>
                        </tr>
                        <tr>
                          <th>Rank</th>
                          <th>Free Spins</th>
                          <th>Bet Value</th>
                          <th>Rollover</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>888</td>
                          <td>6</td>
                          <td rowSpan="6" className="rollover-cell">
                            No Rollover Requirement
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>588</td>
                          <td>5</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>388</td>
                          <td>4</td>
                        </tr>
                        <tr>
                          <td>4-5</td>
                          <td>288</td>
                          <td>3</td>
                        </tr>
                        <tr>
                          <td>6-10</td>
                          <td>188</td>
                          <td rowSpan={2}>2</td>
                        </tr>
                        <tr>
                          <td>11-20</td>
                          <td>88</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal("")} />}
    </>
  )
}
